"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGroupMainRowData = void 0;
const typings_1 = require("../../TableCore/typings");
const getGroupMainRowData = (items, tableType) => {
    if (!items || !items.length) {
        return;
    }
    return findItemForMainRowData(items, tableType);
};
exports.getGroupMainRowData = getGroupMainRowData;
const getItemWithLatestUpdatedDate = items => items.reduce((prevItem, nextItem) => {
    return prevItem.updatedTimestamp > nextItem.updatedTimestamp ? prevItem : nextItem;
});
/*
 * If some of rows have isOnUserLanguage = true we choose that item which has the latest updated date.
 * If some of rows have isOnGlobalLanguage = true (all isOnUserLanguage = false) we choose item with the latest updated date.
 * If none of the rows have isOnUserLanguage & isOnGlobalLanguage equal true we take item with the latest updated date.
 * If some of rows have isOnUserLanguage = true without the latest updated date we take that item which is the first in the array.
 * If some of row have isOnGlobalLanguage = true (all isOnUserLanguage = false) without the latest updated we take that item which is the last in the array.
 * If none of rows have isOnUserLanguage & isOnGlobalLanguage & latest updated date we take first item in the array.
 */
const getItemForDocsAndApprovalsRowGroup = tableData => {
    const { itemsWithUserLanguageAndTime, itemsWithGlobalLanguageAndTime, itemsWithTimestampWithoutLanguages, itemWithUserLanguageWitoutTime, itemWithGlobalLanguageWitoutTime, } = tableData.reduce((acc, item) => {
        if (item.updatedTimestamp) {
            if (item.isOnUserLanguage) {
                acc.itemsWithUserLanguageAndTime.push(item);
            }
            else if (item.isOnGlobalLanguage) {
                acc.itemsWithGlobalLanguageAndTime.push(item);
            }
            else {
                acc.itemsWithTimestampWithoutLanguages.push(item);
            }
        }
        else if (item.isOnUserLanguage) {
            acc.itemWithUserLanguageWitoutTime.push(item);
        }
        else if (item.isOnGlobalLanguage) {
            acc.itemWithGlobalLanguageWitoutTime.push(item);
        }
        return acc;
    }, {
        itemsWithUserLanguageAndTime: [],
        itemsWithGlobalLanguageAndTime: [],
        itemsWithTimestampWithoutLanguages: [],
        itemWithUserLanguageWitoutTime: [],
        itemWithGlobalLanguageWitoutTime: [],
    });
    if (itemsWithUserLanguageAndTime.length) {
        return getItemWithLatestUpdatedDate(itemsWithUserLanguageAndTime);
    }
    if (itemsWithGlobalLanguageAndTime.length) {
        return getItemWithLatestUpdatedDate(itemsWithGlobalLanguageAndTime);
    }
    if (itemsWithTimestampWithoutLanguages.length) {
        return getItemWithLatestUpdatedDate(itemsWithTimestampWithoutLanguages);
    }
    if (itemWithUserLanguageWitoutTime.length) {
        return itemWithUserLanguageWitoutTime[0];
    }
    if (itemWithGlobalLanguageWitoutTime.length) {
        return itemWithGlobalLanguageWitoutTime[itemWithGlobalLanguageWitoutTime.length - 1];
    }
    return tableData[0];
};
/*
 * If some of rows have value updated date we choose item with the latest updated date.
 * If all rows have value updated date empty we choose item which is the first in the array.
 */
const getItemForSoftwareAndDrawingsRowGroup = tableData => {
    const isItemsWithUpdatedDate = tableData.filter(item => !!item.updatedTimestamp);
    if (isItemsWithUpdatedDate.length) {
        return getItemWithLatestUpdatedDate(isItemsWithUpdatedDate);
    }
    return tableData[0];
};
const findItemForMainRowData = (items, tableType) => {
    if (tableType === typings_1.TableTypeEnum.Documents || tableType === typings_1.TableTypeEnum.Approvals) {
        return getItemForDocsAndApprovalsRowGroup(items);
    }
    if (tableType === typings_1.TableTypeEnum.Software || tableType === typings_1.TableTypeEnum.Drawings) {
        return getItemForSoftwareAndDrawingsRowGroup(items);
    }
};
